module.exports = __webpack_public_path__ + "img/prize-04.d70a4035.png";